import { render } from "./AltaCampanaForm.vue?vue&type=template&id=72c024a6&scoped=true"
import script from "./AltaCampanaForm.vue?vue&type=script&lang=js"
export * from "./AltaCampanaForm.vue?vue&type=script&lang=js"

import "./AltaCampanaForm.vue?vue&type=style&index=0&id=72c024a6&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c024a6"]])

export default __exports__